// extracted by mini-css-extract-plugin
module.exports = {"currency__wrapper":"currency_currency__wrapper__1vxJ1","little__circle":"currency_little__circle__-dMpY","btg":"currency_btg__1YN06"};